import dayjs from "dayjs";

 export const getRelativeDate = (updateDate: string) => {
    const today = dayjs().startOf("day");
    const updated = dayjs(updateDate).startOf("day");
    const diffInDays = today.diff(updated, "day");
    return diffInDays === 0 ? "Bugün" : `${diffInDays} Gün Önce`;
  };